import angular from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { AncillariesUtilsService } from '../../../../../../shared/ib-web-ancillaries-utils';

const componentOptions = {
    bindings: {
        bobInfo: '=',
        modules: '=',
        index: '=',
        last: '=',
        flowApp: '=',
        mmbBooked: '='
    },
    controllerAs: 'ibBobBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-bob-box-view.html';
    }]
};


const componentInfo = {
    module: 'ib-bob-box-module',
    selector: 'ibBobBox',
    inject: ['$scope', 'localStorageService', '$rootScope', 'DatalayerUtilsService', 'AncillariesConstants', 'CommonsConstants', 'DatalayerConstants', 'AncillariesUtilsService', 'CommonsUtilService'],
    required: ['']
};

export class ibBobBox implements ng.IController {

    public quanty = 0;
    public specialUser = false;
    public flowApp;
    public bobInfo;
    public mmbBooked = false;
    constructor (
        private $scope: angular.IScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $rootScope: CommonsRootScope,
        private DatalayerUtilsService: DatalayerUtilsService,
        private AncillariesConstants: AncillariesConstant,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private AncillariesUtilsService: AncillariesUtilsService,
        private CommonsUtilService: CommonsUtilService) {

    }

    $onInit () {
        const bobInfo: any = this.localStorageService.get('bobInfo');
        const order: any = this.localStorageService.get('bobOrder');
        if (order) {
            this.quanty = 1;
        } else {
            this.quanty = 0;
        }
        angular.forEach(bobInfo.slices, (slice) => {
            angular.forEach(slice.products, (product) => {
                if (product.price === 0) {
                    this.specialUser = true;
                }
            });
        });
        this.localStorageService.set('specialUserBob', this.specialUser);
    }

    /**
     * Emit event to parent for open modal of BoB
    */
    openModal = (): void => {
        this.localStorageService.remove('lastFieldBob');
        this.localStorageService.set('close', this.AncillariesConstants.QUADRIGAM.ANCILLARIES);
        let trackingCode;
        if(this.flowApp !=='MMB') {
            trackingCode = `${this.$rootScope.appLang}/${this.$rootScope.appMarket}/${this.localStorageService.get('actualStepFlow')}`;
        } else {
            trackingCode = `${this.$rootScope.appLang}/${this.$rootScope.appMarket}/${this.AncillariesConstants.QUADRIGAM.ANCILLARIES_MMB.toLowerCase()}`;
        }
        this.DatalayerUtilsService.updateDatalayerEvents(this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB, trackingCode, this.AncillariesConstants.DATALAYER_INFO.CLICKS_BANNER, this.AncillariesConstants.DATALAYER_INFO.INTERACCION);

        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BOB, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BOB, null, this.localStorageService.get('userLogged'));
        this.AncillariesUtilsService.isBookingFlow() ? this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BOB) :this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BOB);
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updateDigitalData');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
        this.$scope.$emit('openBobModal');
    };

    setQuantityBob = (): void => {
        this.quanty = 1;
    };
}



try {
    const mod = angular.module(componentInfo.module);
    ibBobBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBobBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBobBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBobBox })
    );
}